import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../error';
import { ActivityModel, ActivityStatus, ActivityStatusFlow } from './types';
import { catchError } from 'rxjs/operators';
import { CrudType } from '../../service/message/types';
import { MessageService } from '../../service/message/message.service';
import { Action } from '../view/types';

@Injectable({
  providedIn: 'root',
})
export class ActivityApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
    private readonly messageService: MessageService,
  ) {}

  getById = (id: number): Observable<ActivityModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ActivityModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  createInstance = (): Observable<ActivityModel> => {
    let parameters: string[];
    parameters = ['create'];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ActivityModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  add = (activityModel: ActivityModel): Observable<ActivityModel> => {
    let parameters: string[];
    parameters = [];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .post<ActivityModel>(url, activityModel, {
        observe: 'response',
      })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  update = (activityModel: ActivityModel): Observable<ActivityModel> => {
    let parameters: string[];
    parameters = [activityModel.id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient
      .put<ActivityModel>(url, activityModel, {
        observe: 'response',
      })
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        }),
      );
  };

  getStatusFlow = (
    statusFlow: ActivityStatus,
  ): Observable<ActivityStatusFlow[]> => {
    let parameters: string[];
    parameters = ['statusflow', statusFlow.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ActivityStatusFlow[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  getStatusActions = (statusFlow: ActivityStatus): Observable<Action[]> => {
    let parameters: string[];
    parameters = ['statusactions', statusFlow.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<Action[]>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  markAsDone = (contractId: number): Observable<ActivityModel> => {
    let parameters: string[];
    parameters = ['markasdone', contractId.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<ActivityModel>(url).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.activity.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
